<template>
  <div>
    <h3>
      <router-link class="clearfix" to="/bookStack">
        收藏推荐
        <p class="fr">更多<img src="~img/personal/rightarrow.png" alt="" /></p>
      </router-link>
    </h3>
    <smallSixRecommend :booklist="shelf1"></smallSixRecommend>
    <!-- 我的收藏 -->
    <h3 class="choose">
      <span :class="{ active: chooseActive == 2 }" @click="chooseSeeList(2)"
        >我的收藏</span
      >
      |
      <span :class="{ active: chooseActive == 1 }" @click="chooseSeeList(1)"
        >阅读历史</span
      >
      <!-- <p class="fr">
          查看全部收藏<img src="~img/personal/rightarrow.png" alt="" />
        </p> -->
    </h3>
    <template v-if="chooseActive == 2">
      <template v-if="!newShelfBook">
        <div class="datanull">
          <img src="~img/personal/collect.png" alt="" />
          <p>还没有追过一本书</p>
        </div>
      </template>
      <template v-else>
        <div class="block shelfbox" style="position:relative">
          <dl class="clearfix">
            <dt class="fl" style="position:relative">
              <router-link :to="'/bookdetail/' + newShelfBook.id">
                <img :src="imgURL + newShelfBook.iconUrlMedium" alt="" />
              </router-link>
              <img
                class="deleteobj"
                @click="deleteShelfBook(newShelfBook.id)"
                src="~img/delete.png"
                alt=""
              />
            </dt>
            <dd>
              <h4>
                <router-link :to="'/bookdetail/' + newShelfBook.id">{{
                  newShelfBook.name
                }}</router-link>
                <span class="endstatus" v-if="newShelfBook.finished"
                  >已完结</span
                ><span class="puls" v-else>连载中</span>
              </h4>
              <p class="bookdetail">
                {{ newShelfBook.introduce }}
              </p>
              <router-link
                v-if="newShelfBook.newChapter != null"
                :to="
                  '/book/' + newShelfBook.id + '/' + newShelfBook.newChapter.id
                "
                class="newchapter"
              >
                最后更新：{{
                  newShelfBook.newChapter ? newShelfBook.newChapter.name : ""
                }}
                》
              </router-link>
              <router-link
                v-if="hisbook != null"
                :to="'/book/' + newShelfBook.id + '/' + hisbook.id"
                class="readstatus"
                >读到：{{ hisbook.name }}</router-link
              >
            </dd>
          </dl>
          <ul class="collectlist">
            <li v-for="book in collectLists.items" :key="book.id">
              <router-link :to="'/bookdetail/' + book.id">
                <img v-lazy="imgURL + book.iconUrlMedium" alt="" />
                <p>{{ book.name }}</p>
              </router-link>
              <img
                class="delete"
                @click="deleteShelfBook(book.id)"
                src="~img/delete.png"
                alt=""
              />
            </li>
          </ul>
          <el-pagination
            :hide-on-single-page="true"
            background
            layout="prev, pager, next"
            :total="shelfPage"
            :current-page="coCurrent"
            class="paginnation-book shelfPage"
            @current-change="currentBookChoose"
          >
          </el-pagination>
        </div>
      </template>
    </template>
    <template v-if="chooseActive == 1">
      <div class="block" v-if="historyList.items.length > 0">
        <div>
          <dl class="clearfix" v-for="book in historyList.items" :key="book.id">
            <dt class="fl" style="position:relative">
              <router-link :to="'/bookdetail/' + book.id">
                <img
                  v-lazy="imgURL + book.iconUrlMedium"
                  :src="imgURL + book.iconUrlMedium"
                  alt=""
                />
              </router-link>
              <img
                class="deleteobj"
                @click="deletehisBook(book.id)"
                src="~img/delete.png"
                alt=""
              />
            </dt>
            <dd>
              <h4>
                <router-link :to="'/bookdetail/' + book.id">{{
                  book.name
                }}</router-link>
                <span class="endstatus" v-if="book.finished">已完结</span
                ><span class="puls" v-else>连载中</span>
              </h4>
              <p class="bookdetail">
                {{ book.introduce }}
              </p>
              <router-link
                v-if="book.newChapter"
                :to="'/book/' + book.id + '/' + book.newChapter.id"
                class="newchapter"
              >
                最后更新：{{ book.newChapter ? book.newChapter.name : "" }} 》
              </router-link>
              <router-link
                :to="'/book/' + book.id + '/' + book.historyChapter.id"
                class="readstatus"
                >读到：{{ book.historyChapter.name }}</router-link
              >
            </dd>
          </dl>
        </div>
      </div>
      <div class="datanull" v-else>
        <img src="~img/personal/collect.png" alt="" />
        <p>还没有读过一本书~~</p>
      </div>
      <el-pagination
        background
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :total="hisPageCount"
        :current-page="hisCurrent"
        class="paginnation-book"
        @current-change="currentHistory"
      >
      </el-pagination>
    </template>
    <!-- 我写的书 -->
    <div class="writewrap" v-if="chooseActive == 2 && isShowA">
      <h3>
        我写的书
        <a href="javaScript:" @click="goBookSet(0, false)" class="writebook"
          >创建作品</a
        >
      </h3>
      <writeList
        :booklist="authorlist"
        @openbook="openbook"
        :small="small"
      ></writeList>
      <el-pagination
        :hide-on-single-page="true"
        :page-size="4"
        background
        layout="prev, pager, next"
        :total="authortotalPage"
        class="paginnation-book"
        @current-change="currentChoose"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getwriter } from "utils/storage";
import {
  readhistory,
  getshelf,
  getNewBook,
  deleteshelf,
  deletehistory
} from "@/api/book";
import { AuthorBookList } from "apiurl/author";
import { moreshelf } from "@/api/book";
export default {
  data() {
    return {
      booklist: [],
      authorlist: [],
      authortotalPage: 0,
      fivelist: [],
      small: true,
      historyList: null,
      collectLists: {},
      newShelfBook: null,
      chooseActive: 2,
      hisbook: {},
      shelfPage: 0,
      hisPageCount: 0,
      pageNum: 1,
      hisCurrent: 1,
      coCurrent: 1,
      shelf1: []
    };
  },
  created() {
    // 获取阅读历史第一页
    this.$nextTick(() => {
      // 获取阅读历史列表
      this.getrecordlist(1, 10);
      //  获取书架列表
      this.getshelfList(1, 12);
      // 获取写作列表
      if (getwriter() == "true") {
        this.getwriteList(1);
      }

      // 获取最新收藏
      this.getNewBookFun();
      // shelf
      this.getmoreshelf();
    });
  },
  methods: {
    // 书架列表
    getmoreshelf() {
      moreshelf({ shelfId: "yuanshi_web_recommend" }).then(res => {
        if (res.success) {
          this.shelf1 = res.data.items;
          this.shelf1.forEach(items => {
            items.introduce = items.introduce.substring(0, 40) + "...";
          });
        }
      });
    },
    // 获取阅读历史
    async getrecordlist(pageNum, pageSize) {
      let res = await readhistory({ pageNum, pageSize });
      if (res.success) {
        this.historyList = res.data;
        this.hisPageCount = Number(res.data.totalCount);
        // console.log("tag", this.hisPageCount);
      }
    },
    // 获取收藏列表
    async getshelfList(pageNum, pageSize) {
      let res = await getshelf({ pageNum, pageSize });
      if (res.success) {
        this.collectLists = res.data;
        this.shelfPage = Number(res.data.totalCount);
      }
    },
    // 获取作者写书列表
    async getwriteList(pageNum) {
      let res = await AuthorBookList({ pageSize: 4, pageNo: pageNum });
      if (res.success) {
        this.authorlist = res.data.items;
        this.authortotalPage = Number(res.data.totalCount);
      }
    },
    // 选择指定的页数
    currentChoose(value) {
      this.getwriteList(value);
      this.pageNum = value;
    },
    // 去写新书
    goBookSet(bookid, allowPrice) {
      this.$store.dispatch("setAInfo", {
        bookid: bookid,
        allowPrice: allowPrice,
        name: ""
      });
      this.$router.push("/authorManage/bookSetting/" + bookid);
    },
    // 获取最新一本书
    async getNewBookFun() {
      let res = await getNewBook();
      if (res.success) {
        if (res.data != "") {
          this.newShelfBook = res.data;
          this.hisbook = res.data.historyChapter;
        } else {
          this.newShelfBook = null;
        }
      }
    },
    // 删除收藏的书
    async deleteShelfBook(ids) {
      let res = await deleteshelf({ ids: ids });
      if (res.success) {
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.getshelfList(1, 12);
        // 获取最新收藏
        this.getNewBookFun();
      }
    },
    async deletehisBook(bookIds) {
      let res = await deletehistory({ bookIds });
      if (res.success) {
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.getrecordlist(1, 10);
      }
    },
    // 选择切换
    chooseSeeList(num) {
      this.chooseActive = num;
    },
    currentBookChoose(value) {
      this.coCurrent = value;
      this.getshelfList(value, 12);
    },
    currentHistory(his) {
      this.hisCurrent = his;
      this.getrecordlist(his, 10);
    },
    // 申请发布成功
    openbook() {
      this.getwriteList(this.pageNum);
    }
  }
};
</script>
<style>
.shelfbox .shelfPage {
  bottom: -30px !important;
  right: -11px !important;
}
</style>

<style lang="stylus" scoped>
.block
    dt
        margin-right 20px
        margin-bottom 27px
        a
            display block
            width 100px
            height 140px
            img
                width 100px
                height 140px
        .deleteobj
            position absolute
            top 111px
            left 73px
            cursor pointer
    dd
        font-size 12px
        font-family PingFangSC-Regular
        font-weight 400
        color rgba(136, 136, 136, 1)
        h4
            font-size 8px
            font-weight 400
            color rgba(255, 255, 255, 1)
            margin-bottom 10px
            a
                font-size 16px
                display inline-block
                font-weight 600
                color rgba(51, 51, 51, 1)
                margin-right 10px
            .endstatus
                display inline-block
                background #E5AE58
                color #fff
                font-size 10px
                border-radius 8px
                padding 2px 4px
            .puls
                display inline-block
                background rgba(72, 162, 223, 1)
                font-size 8px
                border-radius 10px
                padding 2px 4px
        .readstatus
            color #999
        .bookdetail
            margin-bottom 24px
            text-overflow ellipsis // 文本溢出显示省略号
            display -webkit-box
            overflow hidden
            height 32px
            -webkit-line-clamp 2
            -webkit-box-orient vertical
        .newchapter
            font-size 12px
            font-family PingFangSC
            font-weight 400
            color rgba(51, 51, 51, 1)
            margin-bottom 10px
            display block
.collectlist
    display block
    overflow hidden
    margin-bottom 50px
    &.mywrite
        li
            width 159px
            margin-right 67px
            margin-bottom 20px
            &:nth-child(3n)
                margin-right 0px
            img
                width 159px
                height 222px
    li
        display inline-block
        position relative
        float left
        margin-right 51px
        margin-bottom 10px
        width 87px
        &:nth-child(6n)
            margin-right 0px
        .delete
            width 28px
            height 28px
            position absolute
            right 0px
            top 80px
            z-index 100
            cursor pointer
        a
            width 100%
            display block
            img
                width 100%
                height 109px
                margin-bottom 10px
            p
                font-size 12px
                font-weight 400
                width 100%
                color rgba(0, 0, 0, 1)
                height 16px
                line-height 16px
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
        .chapters
            padding 10px 0
            font-size 12px
            color #999
            text-align center
            span
                display inline-block
                &:nth-child(1)
                    margin-right 2px
        .buttons
            text-align center
            color #666
            a
                text-decoration none
                color #666
                display inline-block
                width auto
.writewrap
    .writebook
        display inline-block
        width 64px
        height 28px
        background #48A2DF
        font-size 12px
        line-height 28px
        text-align center
        font-weight 500
        color rgba(255, 255, 255, 1)
        margin-left 24px
.choose
    color #999999
    fon-size 16px
    span
        color #999999
        fon-size 16px
        cursor pointer
        &.active
            color #48a2df
.paginnation-book
    position absolute
    right 20px
    bottom 20px
</style>
